import React, { useMemo, useState } from 'react';

export default function SettingsPanel({ title, groups, t }) {
  const [isOpen, setIsOpen] = useState(false);
  const summary = useMemo(() => groups.map(selectedOption).filter(Boolean), [groups]);

  return (
    <section className="mv-settings">
      <div className="mv-settings__bar">
        <div className="mv-settings__title">{title}</div>
        <button className="mv-settings__toggle" onClick={() => setIsOpen((v) => !v)}>
          <span>{t(`videoGeneration.mv.actions.${isOpen ? 'collapse' : 'expand'}`)}</span>
          <span className={`mv-settings__chevron ${isOpen ? 'is-open' : ''}`} />
        </button>
      </div>
      <div className="mv-settings__divider" />
      <button className="mv-settings__summary-btn" onClick={() => setIsOpen((v) => !v)}>
        <div className="mv-settings__summary">
          {summary.length ? summary.map((item) => (
            <span className="mv-settings__chip mv-settings__chip--active" key={`${item.title}-${item.value}`}>
              {item.title}: {item.label}
            </span>
          )) : <span className="mv-settings__placeholder">{t('videoGeneration.mv.actions.selectSettings')}</span>}
        </div>
      </button>
      {isOpen && (
        <div className="mv-settings__body">
          {groups.map((group) => <OptionGroup key={group.title} {...group} />)}
        </div>
      )}
    </section>
  );
}

function OptionGroup({ title, items, value, onChange, isOptionDisabled }) {
  const options = uniqueOptions(items);
  if (!options.length) return null;
  return (
    <div className="mv-group">
      <div className="mv-group__title">{title}</div>
      <div className="mv-options">
        {options.map((item) => (
          <button
            key={item.value}
            className={value === item.value ? 'active' : ''}
            disabled={isOptionDisabled?.(item)}
            onClick={() => onChange(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}

function selectedOption(group) {
  const match = uniqueOptions(group.items).find((item) => item.value === group.value);
  return match ? { ...match, title: group.title } : null;
}

function uniqueOptions(items) {
  const seen = new Set();
  return (Array.isArray(items) ? items : []).map(normalizeOption).filter((item) => {
    const key = optionKey(item);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

function normalizeOption(item) {
  return typeof item === 'string' ? { value: item, label: item } : item;
}

function optionKey(item) {
  const value = String(item.value || '').trim().toLowerCase();
  const label = String(item.label || '').trim().toLowerCase();
  if (['auto', '自动', '自動'].includes(value) || ['auto', '自动', '自動'].includes(label)) return 'auto';
  return value;
}
